import React, { useEffect, useState } from "react";
import { getSuppliersDebt } from "../../utils/dataFetch";
import NewStatementModal from "./NewStatementModal";
import ReportModal from "./ReportSuppliersDebt";

export default function SuppliersDebt({ endDate }) {
    const todayDate = new Date();
    todayDate.setHours(1, 0, 0, 0);
    const checkEndDate = new Date(endDate);
    checkEndDate.setHours(1, 0, 0, 0);

    const [suppliersDebt, setSuppliersDebt] = useState({});
    const [selectedCounterparty, setSelectedCounterparty] = useState(null);
    const [dataError, setDataError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [warningMessage, setWarningMessage] = useState("");

    const [showTable, setShowTable] = useState(false);
    const toggleTable = () => setShowTable(!showTable);

    const [showReport, setShowReport] = useState(false);
    const toggleReport = (counterparty) => {
        setSelectedCounterparty(counterparty);
        setShowReport(!showReport);
    };

    const [showModal, setShowModal] = useState(false);
    const toggleModal = (counterparty) => {
        setSelectedCounterparty(counterparty);
        setShowModal(!showModal);
        if (todayDate > checkEndDate && !showModal) {
            setWarningMessage(
                `Дані про борги постачальниками показані за ${endDate} !`
            );
            setTimeout(() => {
                setWarningMessage("");
            }, 5000);
        }
    };

    const fetchSuppliersDebt = async (endDate) => {
        try {
            const tempEnd = new Date(endDate);
            tempEnd.setHours(23, 59, 59, 999);
            const result = await getSuppliersDebt(tempEnd.toISOString());
            setSuppliersDebt(result);
        } catch (error) {
            setDataError("Помилка завантаження даних!");
        }
    };

    useEffect(() => {
        fetchSuppliersDebt(endDate);
    }, [endDate]);

    return (
        <div className="col-12 col-md-auto dashboard--item flex-fill align-self-center">
            <div className="dashboard--item--container p-3 h-100">
                {successMessage && (
                    <div className="alert alert-success alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {successMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setSuccessMessage("")}
                        ></button>
                    </div>
                )}
                {errorMessage && (
                    <div className="alert alert-danger alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {errorMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setErrorMessage("")}
                        ></button>
                    </div>
                )}
                {warningMessage && (
                    <div className="alert alert-warning alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {warningMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setWarningMessage("")}
                        ></button>
                    </div>
                )}
                <h5 className="text-center fw-bold">Борг постачальникам</h5>
                {dataError && (
                    <div className="alert alert-danger rounded-5 m-auto">
                        {dataError}
                    </div>
                )}
                {!dataError && (
                    <>
                        <div className="row d-flex justify-content-around">
                            <div className="col col-auto m-0 p-0 text-center">
                                <div className="fw-light">
                                    {suppliersDebt.sum}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            {/* Show Table Data */}
                            <button
                                className="btn btn-sm main--button mt-3"
                                onClick={toggleTable}
                            >
                                {showTable ? "Сховати" : "Детальніше"}
                            </button>
                        </div>
                        {showTable && (
                            <div className="mt-3">
                                <div className="table-responsive rounded-4">
                                    <table className="table table-sm table-striped table-light table-hover m-0">
                                        <thead>
                                            <tr>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="col"
                                                >
                                                    Постачальник
                                                </th>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="col"
                                                >
                                                    Борг
                                                </th>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="col"
                                                >
                                                    Дії
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {suppliersDebt.list.map(
                                                (item, index) => (
                                                    <tr key={index}>
                                                        <th
                                                            className="text-center align-middle"
                                                            scope="row"
                                                        >
                                                            {item.name}
                                                        </th>
                                                        <td className="text-center align-middle">
                                                            <span
                                                                className={`px-2 rounded-4 ${
                                                                    parseFloat(
                                                                        item.debt
                                                                    ) < 0 &&
                                                                    "bg-danger-subtle"
                                                                }`}
                                                            >
                                                                {parseFloat(
                                                                    item.debt
                                                                ).toFixed(2)}
                                                            </span>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <button
                                                                className="btn btn-sm btn-light rounded-5 border"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="bi bi-three-dots-vertical"></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            toggleModal(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        Оплатити
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            toggleReport(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        Акт
                                                                        звірки
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* NewStatement Modal */}
                        {showModal && (
                            <NewStatementModal
                                toggleModal={toggleModal}
                                type={"sdPayment"}
                                fetchData={fetchSuppliersDebt}
                                setErrorMessage={setErrorMessage}
                                setSuccessMessage={setSuccessMessage}
                                selectedCounterparty={selectedCounterparty}
                                endDate={endDate}
                            />
                        )}

                        {/* Report Modal */}
                        {showReport && (
                            <ReportModal
                                toggleModal={toggleReport}
                                selectedCounterparty={selectedCounterparty}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
